<template>
    <div class="py-5 px-5">
        <Title/>
        <b-card title="Review Images">

            <!--<b-btn @click="$emit('back')">
                <i class="fas fa-chevron-left pr-1"></i>
                Back to login
            </b-btn>-->
            
            <b-tabs class="pt-3">
                <b-tab title="Incomplete" class="pt-4">

                    <b-row>
                        <b-col cols=4 lg=3 v-for="r in reviews.filter(r => !r.reviewed)" :key="r._id" class="mb-3">
                            <b-card     :img-src="r.screenshot" 
                                        class="text-right" 
                                        style="cursor: pointer"
                                        @click="review = JSON.parse(JSON.stringify(r)); $refs.reviewModal.show()"
                            >
                                {{ r.comments.length }} comment(s)

                                <div class="pt-1">
                                    <b-btn size=sm variant="info" @click.stop="currentImage = r; $refs.shareModal.show()" class="mr-1">Share</b-btn>
                                    <b-btn size=sm variant="danger" @click.stop="deleteReview(r)">Delete</b-btn>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>

                    <div v-if="reviews.filter(r => !r.reviewed).length == 0" class="text-center py-4">
                        <i>There are no images in this category.</i>
                    </div>
                </b-tab>

                <b-tab title="Complete" class="pt-4">

                    <b-row>
                        <b-col cols=4 lg=3 v-for="r in reviews.filter(r => r.reviewed)" :key="r._id" class="mb-3">
                            <b-card     :img-src="r.screenshot" 
                                        class="text-right" 
                                        style="cursor: pointer"
                                        @click="review = JSON.parse(JSON.stringify(r)); $refs.reviewModal.show()"
                            >
                                {{ r.comments.length }} comment(s)

                                <div class="pt-1">
                                    <b-btn size=sm variant="info" @click="currentImage = r; $refs.shareModal.show()" class="mr-1">Share</b-btn>
                                    <b-btn size=sm variant="danger" @click.stop="deleteReview(r)">Delete</b-btn>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>

                    <div v-if="reviews.filter(r => r.reviewed).length == 0" class="text-center py-4">
                        <i>There are no images in this category.</i>
                    </div>
                </b-tab>

                <b-tab title="Shared" class="pt-4">

                    <b-row>
                        <b-col cols=4 lg=3 v-for="r in sharedReviews" :key="r._id" class="mb-3">
                            <b-card     :img-src="r.screenshot" 
                                        class="text-right" 
                                        style="cursor: pointer"
                                        @click="review = JSON.parse(JSON.stringify(r)); $refs.reviewModal.show()"
                            >
                                {{ r.comments.length }} comment(s)

                                <div class="pt-1 text-muted">
                                    {{ r.reviewed? 'Complete' : 'In Progress'}}
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>

                     <div v-if="sharedReviews.length == 0" class="text-center py-4">
                        <i>There are no images in this category.</i>
                    </div>

                </b-tab>

            </b-tabs>

        </b-card>

        <b-modal title="Review Screenshot" ref="reviewModal"  @ok="updateReview">
            <div v-if="review">
                <b-img :src="review.screenshot" responsive thumbnail />

                <b-form-group v-for="(comment,index) in review.comments" :key="index"  
                                :label="(comment.name || 'Reviewer') + ' commented:'" class="mt-2">
                    <b-textarea v-model="comment.text" :disabled="true" no-resize />
                </b-form-group>

                <b-form-group label="Add your comments">
                    <b-textarea rows=2 max-rows=3 no-resize v-model="comment" />

                    <b-row class="pt-3">
                        <b-col lg="6" class="pb-2">
                            <b-button  variant="primary" 
                            @click="review.comments.push({ userId: user._id, name: `${user.firstName} ${user.lastName}`, 
                            text: comment });comment = '', updateReview()"> Add comment
                            </b-button>
                            
                        </b-col>

                        <b-col lg="6" class="pb-2 text-right">
                            <b-button variant="primary" @click="comment = ''"> Delete comment
                            </b-button>
                        </b-col>
                    </b-row>
                        
                    <!-- <div class="text-left pt-2"> -->
                        <!-- <b-btn variant="primary" class="left " @click="review.comments.push({  -->
                            <!-- userId: user._id, name: `${user.firstName} ${user.lastName}`, text: comment }); -->
                             <!-- comment = '', updateReview()" -->
                        <!-- >Add comment</b-btn> -->

                    <!-- </div> -->

                </b-form-group>

                <b-form-group label="Review Completed?">
                    <b-radio-group v-model="review.reviewed">
                        <b-radio :value="false">Incomplete</b-radio>
                        <b-radio :value="true">Complete</b-radio>
                    </b-radio-group>
                </b-form-group>
            </div>

        </b-modal>

        <b-modal title="Share Image" @ok="share" ref="shareModal">
            <b-form-group label="Users to share with" description="Enter emails seperated by commas">
                <b-form-input v-model="emails" />
            </b-form-group>

            <h6>Shared with:</h6>
            <b-list-group v-if="currentImage.sharedWith">
                <b-list-group-item v-for="email in currentImage.sharedWith" :key="email">{{ email }}</b-list-group-item>
            </b-list-group>

            <b-alert v-else show>Not shared with anyone.</b-alert>
        </b-modal>
        <div class="text-left">
            <b-link :to="{ name: 'Dashboard' }">Go Back</b-link>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import axios from 'axios';
import Title from '@/components/Title'

// eslint-disable-next-line no-unused-vars
const baseUrl = process.env.VUE_APP_SERVER;//'https://ed.smartlabsltd.com';

export default {
    data() {
        return {
            reviews: [],
            sharedReviews: [],
            review: {},

            comment: '',
            user: {},

            emails: '',
            currentImage: {}
        }
    },
components: {Title},
    async mounted() {
        this.user = await this.$app.service('users').get('$userId');
        this.loadReviews();

        // this.$app.authenticate()
        // .then(() => this.$router.push({ name: 'Images' }))
    },

    methods: {
        async loadReviews() {
            var response = await this.$app.service('images').find({ query: { userId: '$userId' }});
            this.reviews = response.data;
            this.reviews.forEach(r => {
                if (!r.reviewerComments) {
                    this.$set(r, 'reviewerComments', '');
                }

                if (!r.reviewed) {
                    this.$set(r, 'reviewed', false);
                }
            });

            this.sharedReviews = (await this.$app.service('images').find({ query: { sharedWith: '$userEmail' }})).data
        },

        async updateReview() {
            delete this.review.userId;

            // eslint-disable-next-line no-unused-vars
            var response = await this.$app.service('images').patch(this.review._id, this.review);
            this.loadReviews();
        },

        // eslint-disable-next-line no-unused-vars
        async deleteReview(review) {
            // eslint-disable-next-line no-unused-vars
            var response = await this.$app.service('images').remove(this.review._id);
            this.loadReviews();
        },

        share() {
            var users = this.currentImage.sharedWith || [];
            var newUsers = this.emails.split(',');
            users.push(...newUsers);
            this.$set(this.currentImage, 'sharedWith', users);
            this.$app.service('images').patch(this.currentImage._id, { sharedWith: users });
        }
    }
}
</script>